import { Injectable } from '@angular/core';
import { BannerModel, BannerRequestModel } from '../_models/banner.model';
import { HttpMethodsService } from './http-methods.services';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BannersService {
  constructor(private _httpService: HttpMethodsService) {}

  /**
   * Obtiene un banner por ID.
   * ESTÁNDAR APLICADO: Mapea la respuesta HTTP a instancia de BannerModel
   * para asegurar que el store NgRx contenga objetos correctamente instanciados.
   *
   * @param id - UUID del banner
   * @returns Observable con instancia de BannerModel
   */
  findOne(id: string) {
    return this._httpService.get(`banner`, { id }).pipe(
      map((res: any) => {
        return new BannerModel(res?.data);
      })
    );
  }

  /**
   * Obtiene lista de banners con filtros.
   * ESTÁNDAR APLICADO: TODAS las respuestas HTTP se mapean a modelos usando RxJS map().
   *
   * @param filters - Objeto con filtros: offset, limit, active, search
   * @returns Observable con data (array de BannerModel), total y activeCount
   */
  findAll(filters: any = {}) {
    return this._httpService.get('banners', {}, filters).pipe(
      map((res: any) => {
        return {
          data: res?.data.map((r: any) => new BannerModel(r)),
          total: res?.total || res?.data?.length || 0,
          activeCount: res?.activeCount || 0,
        };
      })
    );
  }

  /**
   * Crea un nuevo banner.
   * ESTÁNDAR APLICADO: Patrón de 2 pasos - la imagen ya fue subida previamente por InputImageComponent
   * (automaticUpload=true), el image_id ya viene en el objeto data.
   *
   * @param data - BannerRequestModel con name, title, description e image_id
   * @returns Observable con respuesta del backend
   */
  create(data: BannerRequestModel) {
    // La imagen ya está subida (automaticUpload=true en InputImageComponent)
    // El image_id ya viene en data
    return this._httpService.post('banners', data);
  }

  update(id: string, data: BannerRequestModel) {
    return this._httpService.patch('banner', data, { id });
  }

  toggle(id: string, active: boolean) {
    return this._httpService.patch(`banner_toggle`, { active }, { id });
  }

  remove(id: string) {
    return this._httpService.delete('banner', { id });
  }
}
